module.exports = __webpack_public_path__ + "static/media/documents-icon-active.a3835a08.svg";